module.exports = __webpack_public_path__ + "static/maskvideo-2d1098e1300582f6ae8990c5b9996d33.mp4";